import { supabase } from '../lib/supabase';
import type { LinhaDatasBoleto, LinhaDatasFatura } from '../../types';

/** Todas as faturas do relatório "Datas das faturas" numa chamada só (RPC, não a view:
 *  pela view o PostgREST corta em 1.000 linhas e cada página recalcula tudo).
 *  Período opcional em 'YYYY-MM', inclusivo. */
export async function carregarDatasFaturas(mesDe?: string | null, mesAte?: string | null): Promise<LinhaDatasFatura[]> {
  const { data, error } = await supabase.rpc('relatorio_datas_faturas', {
    p_mes_de: mesDe ?? null,
    p_mes_ate: mesAte ?? null,
  });
  if (error) throw new Error(error.message);
  return (data as LinhaDatasFatura[] | null) ?? [];
}

/** Todos os boletos do relatório "Datas dos boletos", pelo mesmo motivo (RPC, uma chamada).
 *  Período opcional em 'YYYY-MM', inclusivo. */
export async function carregarDatasBoletos(mesDe?: string | null, mesAte?: string | null): Promise<LinhaDatasBoleto[]> {
  const { data, error } = await supabase.rpc('relatorio_datas_boletos', {
    p_mes_de: mesDe ?? null,
    p_mes_ate: mesAte ?? null,
  });
  if (error) throw new Error(error.message);
  return (data as LinhaDatasBoleto[] | null) ?? [];
}
